import { shallowEqual, useSelector } from "react-redux";
import { redirectToPages } from "../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { UserLogsFilter } from "./user-logs-filter/UserLogsFilter";
import { UserLogsTable } from "./user-logs-table/UserLogsTable";

export function UserLogsCard() {
  // Getting curret state of User Logs list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.userLogs }),
    shallowEqual
  );
  const { actionsLoading, isSuccess, type } = currentState;

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);  

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title="Kullanıcı Logları" />
      <CardBody>
        <UserLogsFilter />
        <UserLogsTable />
      </CardBody>
    </Card>
  );
}